import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-greenwich-feedback',
    templateUrl: './greenwich-feedback.component.html',
    styleUrls: ['./greenwich-feedback.component.scss'],
})
export class GreenwichFeedbackComponent implements OnInit {
    @Input() questionAnswer: any = {
        questions: {
            radioData: [
                {
                    labelName: 'Common Questions',
                    question:
                        'Is the student giving interview is same as in passport?',
                    answer: 'Y',
                    answerType: 'radio',
                    asnwerValues: [
                        {
                            id: 'passport_check1',
                            values: 'Yes',
                        },
                        {
                            id: 'passport_check2',
                            values: 'No',
                        },
                        {
                            id: 'passport_check3',
                            values: 'Doubtful',
                        },
                    ],
                    categoryName: 'Common',
                    optionalFields: [],
                    subQuestions: [
                        {
                            labelName: 'Doubtful Questions',
                            questions: 'Please confirm your Date of Birth',
                            categoryName: 'Doubtful',
                            answerType: 'radio',
                            answerValues: [
                                {
                                    id: 'doubt_dob1',
                                    values: 'Answered',
                                },
                                {
                                    id: 'doubt_dob2',
                                    values: 'Not Answered',
                                },
                            ],
                            optionalFields: [],
                        },
                        {
                            labelName: 'Doubtful Questions',
                            questions: 'Please tell me your place of birth',
                            categoryName: 'Doubtful',
                            answerType: 'radio',
                            answerValues: [
                                {
                                    id: 'doubt_dobplace1',
                                    values: 'Answered',
                                },
                                {
                                    id: 'doubt_dobplace2',
                                    values: 'Not Answered',
                                },
                            ],
                            optionalFields: [],
                        },
                    ],
                },
                {
                    labelName: 'Common Questions',
                    question:
                        'The interview will take approximately 30 minutes. Are you feeling fit and well enough to be interviewed today?',
                    answer: 'Not Answered',
                    answerType: 'radio',
                    asnwerValues: [
                        {
                            id: 'interview_ans1',
                            values: 'Answered',
                        },
                        {
                            id: 'interview_ans2',
                            values: 'Not Answered',
                        },
                    ],
                    categoryName: 'Common',
                    optionalFields: [],
                },
                {
                    labelName: 'Common Questions',
                    question:
                        'Can you hear me clearly and understand what I am saying?',
                    answer: 'Answered',
                    answerType: 'radio',
                    asnwerValues: [
                        {
                            id: 'hear_me1',
                            values: 'Answered',
                        },
                        {
                            id: 'hear_me2',
                            values: 'Not Answered',
                        },
                    ],
                    categoryName: 'Common',
                    optionalFields: [],
                },
                {
                    labelName: 'Common Questions',
                    question:
                        'Please can you tell me your full name and date of birth?',
                    answer: 'Answered',
                    answerType: 'radio',
                    asnwerValues: [
                        {
                            id: 'birth_ans1',
                            values: 'Answered',
                        },
                        {
                            id: 'birth_ans1',
                            values: 'Not Answered',
                        },
                    ],
                    categoryName: 'Common',
                    optionalFields: [],
                },
                {
                    labelName: 'Common Questions',
                    question:
                        'Which course have you applied to study at University of Greenwich?',
                    answer: 'Answered',
                    answerType: 'radio',
                    asnwerValues: [
                        {
                            id: 'appliedstudy_ans1',
                            values: 'Answered',
                        },
                        {
                            id: 'appliedstudy_ans2',
                            values: 'Not Answered',
                        },
                    ],
                    categoryName: 'Common',
                    optionalFields: [],
                },
                {
                    labelName: 'Common Questions',
                    question:
                        'I am going to be typing my questions and your answers down therefore I need you to speak slowly and clearly for me. If at any point you are speaking too fast, I will ask you to stop slow down and repeat what you just said. Is this okay?',
                    answer: 'Not Answered',
                    answerType: 'radio',
                    asnwerValues: [
                        {
                            id: 'type_qus1',
                            values: 'Answered',
                        },
                        {
                            id: 'type_qus2',
                            values: 'Not Answered',
                        },
                    ],
                    categoryName: 'Common',
                    optionalFields: [],
                },
            ],
            decisionRadioData: [
                {
                    labelName: 'Decision Questions',
                    question: 'Have you understood all the questions?',
                    answer: 'Answered',
                    answerType: 'radio',
                    asnwerValues: [
                        {
                            id: 'all_ans1',
                            values: 'Answered',
                        },
                        {
                            id: 'all_ans2',
                            values: 'Not Answered',
                        },
                    ],
                    categoryName: 'Decision',
                    optionalFields: [],
                    subQuestions: [],
                },
                {
                    labelName: 'Decision Questions',
                    question: 'Is there anything else you wish to add?',
                    answer: 'Not Answered',
                    answerType: 'radio',
                    asnwerValues: [
                        {
                            id: 'anything_else1',
                            values: 'Answered',
                        },
                        {
                            id: 'anything_else2',
                            values: 'Not Answered',
                        },
                    ],
                    categoryName: 'Decision',
                    optionalFields: [],
                    subQuestions: [],
                },
                {
                    labelName: 'Decision Questions',
                    question:
                        'Are you happy with the conduct of the interview?',
                    answer: 'Answered',
                    answerType: 'radio',
                    asnwerValues: [
                        {
                            id: 'int_happy1',
                            values: 'Answered',
                        },
                        {
                            id: 'int_happy2',
                            values: 'Not Answered',
                        },
                    ],
                    categoryName: 'Decision',
                    optionalFields: [],
                    subQuestions: [],
                },
            ],
            interviewQuestion: [
                {
                    labelName: 'Interview Questions',
                    question: 'Why did you choose the University of Greenwich?',
                    questionNo: '1',
                    label: '',
                    answer: 'abcd',
                    decision: '',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question: 'University details known',
                                answer: 'Y',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question: 'Evidence of research',
                                answer: 'N',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question: 'Vague/Generic answer',
                                answer: 'N',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 2',
                                question: 'Lack of university knowledge',
                                answer: 'Y',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    question: 'What do you know about University of Greenwich?',
                    questionNo: 'a',
                    label: '',
                    answer: 'efgh',
                    decision: 'A',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question: 'University details known',
                                answer: 'N',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question: 'Lack of university knowledge',
                                answer: 'Y',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    question:
                        'Where did you find information about Greenwich, and how did this influence your decision?',
                    questionNo: 'b',
                    label: '',
                    answer: 'mnop',
                    decision: 'G',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question: 'Evidence of research',
                                answer: 'Y',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question: 'Vague/generic answer',
                                answer: 'N',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    question:
                        'Did anyone help you make your decision to study at Greenwich?',
                    questionNo: 'c',
                    label: '',
                    answer: '',
                    decision: '',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question: '',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question: 'Too much Agent influence',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    question:
                        'What other UK universities could you have chosen? Why didn’t you?',
                    questionNo: 'd',
                    label: 'COMPULSORY QUESTION - failure to give a credible answer will result in an instant 2nd interview',
                    answer: 'sds',
                    decision: 'R',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question: 'List alternatives considered',
                                answer: 'Y',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question:
                                    'Explains why this university is a better fit',
                                answer: 'N',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question: 'Evidence of research',
                                answer: 'N',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question: 'No alternatives considered',
                                answer: 'Y',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 2',
                                question: 'Too much Agent influence',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    question: 'Why did you choose to study in the UK?',
                    questionNo: 'e',
                    label: '',
                    answer: '',
                    decision: '',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question: 'Benefits specific to UK',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question: 'Details of course included',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question: 'Details of institution',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question: 'Non-study benefits only',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    question:
                        'Do you know the position of Greenwich in UK university league table? Where did you find this?',
                    questionNo: 'f',
                    label: 'COMPULSORY QUESTION - failure to give a credible answer will result in an instant 2nd interview',
                    answer: 'sdaasds',
                    decision: 'A',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question: 'Realistic response',
                                answer: 'N',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question: 'Compared to other Universities',
                                answer: 'Y',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question: 'Unrealistic/no response',
                                answer: 'N',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    question: 'Why did you choose your course?',
                    questionNo: '2',
                    label: '',
                    answer: '',
                    decision: '',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question: 'Course content details',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question: 'Evidence of research',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question: 'Logical next step',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question: 'Required for future plans',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question:
                                    'Knowledge of what the course entails',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question: 'Vague/Generic answer',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 2',
                                question: 'Lack of course knowledge',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 2',
                                question:
                                    'No clear need to studyLack of course knowledge',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 2',
                                question:
                                    'Unable to provide a description of what the course entails',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    question: 'Do you know how much your course will cost?',
                    questionNo: 'a',
                    label: '',
                    answer: '',
                    decision: '',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question:
                                    'Able to give a realistic estimate or exact cost',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question: 'Not able to give realistic figure',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    question:
                        'Do you know which campus you will be studying at and would you be able to find it on a map?',
                    questionNo: 'b',
                    label: '',
                    answer: '',
                    decision: '',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question: 'Realistic Response',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question: 'No/Unrealistic response',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    question: 'Where do you plan to live in the UK?\t',
                    questionNo: '3',
                    label: '',
                    answer: '',
                    decision: '',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question: 'Location of accommodation',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question: 'Details of accommodation',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question: 'Unrealistic location/response',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    question:
                        'What are the advantages and disadvantages of this type of accommodation?\t',
                    questionNo: 'a',
                    label: '',
                    answer: '',
                    decision: '',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question: 'Evidence of research',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question: 'Vague/generic response\t',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    question:
                        'How much will accommodation cost? Think about your monthly budget.\t',
                    questionNo: 'b',
                    label: '',
                    answer: '',
                    decision: '',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question: 'Accurate knowledge',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question:
                                    'Considered costs in plans and finances\t',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question: 'Incorrect or lack of knowledge',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 2',
                                question: 'Overreliance on work',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    question:
                        'How do you intendto travel betweenthe campus and youraccommodation?',
                    questionNo: '4',
                    label: '',
                    answer: '',
                    decision: '',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question: 'Realistic Response',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question: 'No/Unrealistic response',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    question: 'How do people travel around?',
                    questionNo: 'a',
                    label: '',
                    answer: '',
                    decision: '',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question:
                                    'Different modes of transport are given',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question: 'No/Unrealistic response',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    question:
                        'Do you know how much you are likely to spend travelling to university?',
                    questionNo: 'b',
                    label: '',
                    answer: '',
                    decision: '',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question: 'Any costs given accurate',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question: 'High costs not accounted for',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    question: 'Do you know about student travel discounts?',
                    questionNo: 'c',
                    label: '',
                    answer: '',
                    decision: '',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question: 'Realistic response',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question:
                                    'Will consider looking into it further',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question: 'High costs not accounted for',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    question: 'How will you fund your studies?',
                    questionNo: '5',
                    label: 'COMPULSORY QUESTION – failure to give a credible answer will result in an instant 2nd interview',
                    answer: '',
                    decision: '',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question: 'Sustainable source of income',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question: 'Credible source of income',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question: 'Evidence available\t',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question: 'Evidence available\t',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question: 'High costs not accounted for',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 2',
                                question: 'No evidence of income stated',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 2',
                                question: 'Overreliance on work in UK',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    question:
                        'How much money will you need to live in the UK? Where did you find this information?',
                    questionNo: 'a',
                    label: '',
                    answer: '',
                    decision: '',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question: 'Accurate knowledge',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question:
                                    'Considered costs in plans and finances',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question: 'Incorrect or lack of knowledge',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 2',
                                question: 'Overreliance on work',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    question:
                        'Are you planning to work part-time while you are studying? Do you know what the restrictions are?',
                    questionNo: 'b',
                    label: '',
                    answer: '',
                    decision: '',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question: 'UKVI guidelines mentioned',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question: 'Unrealistic/no response\t',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    question:
                        'How will you fund your subsequent year’s fees (if course is longer than a year)?',
                    questionNo: 'c',
                    label: '',
                    answer: '',
                    decision: '',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question: 'Sustainable source of income',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question: 'Credible source of income',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question: 'Evidence available',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question:
                                    'Unsustainable or non-credible source of income',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 2',
                                question: 'No evidence of income stated',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 2',
                                question: 'Overreliance on work in UK',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    question:
                        'How will your course help with your future plans?',
                    questionNo: '6',
                    label: 'COMPULSORY QUESTION – failure to give a credible answer will result in an instant 2nd interview',
                    answer: '',
                    decision: '',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question: 'Clear plan for after study',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question: 'Realistic plans relevant to study',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question:
                                    'States why course is needed to achieve those plans',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question: 'No/unrealistic plans',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 2',
                                question: 'No clear plan to achieve aim',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 2',
                                question:
                                    'Could be achieved without this course',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 2',
                                question: 'No/unrealistic plans',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    question:
                        'What do you think you will be doing in ten years’ time?',
                    questionNo: 'a',
                    label: '',
                    answer: '',
                    decision: '',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question: 'Realistic plans relevant to study',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question: 'No/unrealistic plans',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    question: 'How much do you expect to be earning?',
                    questionNo: 'b',
                    label: 'COMPULSORY QUESTION – failure to give a credible answer will result in an instant 2nd interview',
                    answer: '',
                    decision: '',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question: 'Realistic response',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question: 'Evidence of research',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question: 'No/unrealistic plans',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 2',
                                question: 'Lack of research',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    question:
                        'You have previously studied in the UK – why have you chosen to return?',
                    questionNo: '7',
                    label: 'Questions depending on Checklist:',
                    answer: '',
                    decision: '',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question:
                                    'Demonstrates a clear need to return to study now',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question: 'Consistent with prior information',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question:
                                    'No logical reason to return to study now',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 2',
                                question: 'Inconsistent with prior info',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    question:
                        'You have had a long break in your studies, why are you returning to study now?',
                    questionNo: 'b',
                    label: '',
                    answer: '',
                    decision: '',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question: 'Sound explanation of reason',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question:
                                    'Demonstrates a clear need to return to study now',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question: 'Consistent with prior information',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question:
                                    'Could be achieved without this course',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
                {
                    labelName: 'Interview Questions',
                    question:
                        'Do you plan on bringing dependents? If yes, how do you plan on financially supporting them?',
                    questionNo: 'c',
                    label: '',
                    answer: 'saqwewqe',
                    decision: 'R',
                    answerType: 'textarea',
                    answerValues: [
                        {
                            id: 'R',
                            values: 'R',
                        },
                        {
                            id: 'A',
                            values: 'A',
                        },
                        {
                            id: 'G',
                            values: 'G',
                        },
                    ],
                    categoryName: 'Interview',
                    optionalFields: [],
                    subQuestions: [
                        [
                            {
                                labelName: 'Subquestion 1',
                                question: 'Primary focus on study',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question:
                                    'Explanation of how the situation will be managed',
                                answer: 'Y',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 1',
                                question: 'Consistent with prior information',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                        [
                            {
                                labelName: 'Subquestion 2',
                                question: 'Commitments at home',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 2',
                                question: 'No clear plans for support',
                                answer: '',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                            {
                                labelName: 'Subquestion 2',
                                question: 'Inconsistent with prior info',
                                answer: 'N',
                                answerType: 'radio',
                                answerValues: [
                                    {
                                        id: 'Y',
                                        values: 'Y',
                                    },
                                    {
                                        id: 'N',
                                        values: 'N',
                                    },
                                ],
                                optionalFields: [],
                            },
                        ],
                    ],
                },
            ],
            additionalQuestion: [
                {
                    labelName: 'Additional Questions',
                    question: '',
                    answer: '1',
                    answerType: 'checkbox',
                    asnwerValues: [
                        {
                            id: 'Mostly green - Pass',
                            values: 'Mostly green - Pass',
                        },
                        {
                            id: 'Mostly amber - Re-assess 2ndInterview',
                            values: 'Mostly amber - Re-assess 2ndInterview',
                        },
                        {
                            id: 'Any red Refer to Line Manager',
                            values: 'Any red Refer to Line Manager',
                        },
                    ],
                    categoryName: 'Additional',
                    optionalFields: [],
                    subQuestions: [],
                },
                {
                    labelName: 'Additional Questions',
                    question: 'Please include Feedback:',
                    answer: 'Good Interview',
                    answerType: 'textarea',
                    asnwerValues: [],
                    categoryName: 'Additional',
                    optionalFields: [],
                    subQuestions: [],
                },
                {
                    labelName: 'Additional Questions',
                    question: 'How many interviews were undertaken?',
                    answer: 'ddad',
                    answerType: 'input',
                    asnwerValues: [],
                    categoryName: 'Additional',
                    optionalFields: [],
                    subQuestions: [],
                },
                {
                    labelName: 'Additional Questions',
                    question: 'What areas did they have to improve on?',
                    answer: 'All feilds',
                    answerType: 'textarea',
                    asnwerValues: [],
                    categoryName: 'Additional',
                    optionalFields: [],
                    subQuestions: [],
                },
                {
                    labelName: 'Additional Questions',
                    question: 'Can you hear me clearly?',
                    answer: 'Yes',
                    answerType: 'input',
                    asnwerValues: [],
                    categoryName: 'Additional',
                    optionalFields: [],
                    subQuestions: [],
                },
                {
                    labelName: 'Additional Questions',
                    question: 'Is it a good time for the interview?',
                    answer: 'Yes',
                    answerType: 'input',
                    asnwerValues: [],
                    categoryName: 'Additional',
                    optionalFields: [],
                    subQuestions: [],
                },
                {
                    labelName: 'Additional Questions',
                    question: 'Passport shown:',
                    answer: 'Yes',
                    answerType: 'input',
                    asnwerValues: [],
                    categoryName: 'Additional',
                    optionalFields: [],
                    subQuestions: [],
                },
                {
                    labelName: 'Additional Questions',
                    question: 'Please indicate what region they are from :',
                    answer: 'India',
                    answerType: 'input',
                    asnwerValues: [],
                    categoryName: 'Additional',
                    optionalFields: [],
                    subQuestions: [],
                },
                {
                    labelName: 'Additional Questions',
                    question: 'Any previous refusals (any country) :',
                    answer: 'No',
                    answerType: 'input',
                    asnwerValues: [],
                    categoryName: 'Additional',
                    optionalFields: [],
                    subQuestions: [],
                },
            ],
        },
    };
    @Input() interviewDetails: any = {
        _id: '66d1b43b0297f3ea878b7eee',
        id: '1725019195',
        studentName: 'new   test',
        passportNo: 'OIP67A89',
        applicationId: '717436',
        masterId: 'GGOz1721371238',
        universityId: '3',
        universityName: 'University of Greenwich',
        agentId: '1306',
        agentName: 'UCOL',
        courseId: '12345',
        courseName: 'Advanced Chemical Engineering, MSc',
        tenantId: '16',
        tenantName: 'UCOL Ltd.',
        intakeId: '61',
        intake: 'August/September/October/November 2023',
        interviewDate: '30-08-2024',
        interviewTime: '09:45-11:45',
        interviewType: '1719492224',
        interviewMode: '1718954586',
        modeId: 'https://zoom.us/j/sdsda',
        contactInfo: '+912561524312',
        country: 'India',
        countryId: '99',
        requestDate: '1725019195',
        assignTo: '868',
        createdId: '868',
        updated: ['868'],
        assignOn:
            'Fri Aug 30 2024 12:11:21 GMT+0000 (Coordinated Universal Time)',
        updateStatus: null,
        assignBy: '868',
        qualityMaster: null,
        status: 'true',
        comment: 'sadsad',
        html: '',
        numberOfAttempt: '1',
        interviewStatus: '3',
        interviewFeedback: 'Good interview',
        createdAt: '2024-08-30T11:59:55.480Z',
        updatedAt: '2024-08-30T11:59:55.480Z',
        __v: 0,
        interviewDuration: '40 Minutes',
        interviewerName: 'Junaid Pasha',
    };

    ngOnInit(): void {
        console.log(this.questionAnswer, this.interviewDetails);
    }
}
